import { Injectable } from '@angular/core';
import { TransactionStatusOptions } from '../model/Transaction';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor() { }


  public getStatusText(status: string) {
    if (status == TransactionStatusOptions.CompletedWithErrors)
      return "Completed with Errors";
    if (status == TransactionStatusOptions.InProgress)
      return "In Progress";

    return status;
  }

}
